export default __webpack_public_path__ + "static/media/New_Layer.7aef5457.png";